import { defineMessages } from 'react-intl'

export default defineMessages({
  description: {
    id: 'boost.profile-modal.description',
    defaultMessage:
      'Boost your profile to the top of search results and find a roommate faster!'
  },
  success: {
    id: 'boost.profile-modal.success',
    defaultMessage: 'Profile Boosted!'
  },
  successDescription: {
    id: 'boost.profile-modal.success_description',
    defaultMessage:
      'Your Profile has been boosted in the search results. For even more hits, start messaging potential roommates directly!'
  }
})
